// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"Qk","summaryPar":"Rk","ratingCategories":"Sk","reviewerInfo":"Tk","reviewTypes":"Uk","expanded":"Vk"};